<template>
  <BreadCrumb :PageTitle="t('breadCrumb.organisationlist')" />
  <CustomersList />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CustomersList from "../../components/CRM/CustomersList/CustomersList.vue"; 
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "CustomersListPage",
  components: {
    BreadCrumb,
    CustomersList,
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  }
});
</script>